"use strict";

var takeAll = require("./takeAll.js");

var reverseL = require("../Lazy/reverseL.js");

const reverse = iter => takeAll(reverseL(iter));

module.exports = reverse;